/* Shopify owns eligibility and savings. This only presents the dated offer. */
(() => {
  'use strict';
  function init(){
    document.querySelectorAll('[data-basket-offer]').forEach(root=>{
      if(root.dataset.offerReady)return;
      root.dataset.offerReady='true';
      const starts=Date.parse(root.dataset.offerStart),ends=Date.parse(root.dataset.offerEnd);
      let timer,seen=false;
      function current(){return Number.isFinite(starts)&&Number.isFinite(ends)&&Date.now()>=starts&&Date.now()<ends;}
      function refresh(){
        clearTimeout(timer);root.hidden=!current();
        if(!root.hidden)timer=setTimeout(refresh,Math.min(ends-Date.now(),86400000));
      }
      function record(action){
        if(!current()||!window.KillinBehavior?.enabled)return false;
        window.KillinBehavior.record('cart',{action,experiment:root.dataset.offerId,source:root.dataset.offerContext});return true;
      }
      function impression(){if(!seen&&!root.hidden&&root.getBoundingClientRect().bottom>0&&root.getBoundingClientRect().top<innerHeight)seen=record('basket_offer_view');}
      root.querySelector('[data-offer-link]')?.addEventListener('click',()=>record('basket_offer_shop'));
      if(root.dataset.offerContext==='cart'){
        root.closest('form')?.querySelectorAll('[name="updates[]"]').forEach(input=>input.addEventListener('change',()=>{
          root.querySelector('[data-offer-message]').textContent='Update your cart to refresh your offer progress.';
          const progress=root.querySelector('[data-offer-progress]');if(progress)progress.hidden=true;
        }));
      }
      document.addEventListener('visitorConsentCollected',impression);
      document.addEventListener('visibilitychange',()=>{refresh();impression();});
      window.addEventListener('pageshow',()=>{refresh();impression();});
      window.addEventListener('pagehide',()=>clearTimeout(timer));
      refresh();impression();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
